import type { FC, ReactNode } from 'react';

interface TopBarShellProps {
  enabled: boolean;
  topBar: ReactNode;
  children: ReactNode;
}

export const TopBarShell: FC<TopBarShellProps> = ({ enabled, topBar, children }) => {
  if (!enabled) return children;

  return (
    <>
      {topBar && <div className="hidden md:block">{topBar}</div>}
      <div className="flex min-h-0 flex-1">{children}</div>
    </>
  );
};
